@if (processView$ | async; as processView) {
	<article class="activator-execution mulitple-groups">
		@if (
			processView.enactmentActivatorExecutionContainer!.activators.length == 0 &&
			processView.enactmentActivatorExecutionContainer!.results.items.length == 0
		) {
			<p class="empty" translate="none"></p>
		}
		@if (
			processView.enactmentActivatorExecutionContainer!.activators.length > 0 ||
			processView.enactmentActivatorExecutionContainer!.results.items.length > 0
		) {
			<ul class="grouped-list">
				@if (processView.enactmentActivatorExecutionContainer!.activators.length > 0) {
					<li class="group">
						<header class="group-header">
							<span class="h3"
								(click)="toggle(activatorsGroupIdent)"
								translate="process.enactment.activator.execution.activatorssection"
							></span>
							<span class="counter">{{ processView.enactmentActivatorExecutionContainer!.activators.length }}</span>
							<stages-button-expand-collapse
								[classes]="'action menu-button'"
								[isCollapsed]="!isGroupOpen(activatorsGroupIdent)"
								(pressedButton)="toggle(activatorsGroupIdent)"
							></stages-button-expand-collapse>
						</header>
						<div class="relative-container">
							<div class="animation-container">
								<div
									#expandableActivatorsGroup
									class="stages-expand-collapse-from-top"
									[class.stages-expanded]="isGroupOpen(activatorsGroupIdent)"
									[class.stages-collapsed]="!isGroupOpen(activatorsGroupIdent)"
								>
									<div>
										<ul class="list dense">
											@for (
												activator of processView.enactmentActivatorExecutionContainer!.activators;
												track activator
											) {
												<li class="list-item">
													@if (!isExecutionDisabled(processView)) {
														<a
															(click)="startExecution({ processView: processView, activatorView: activator })"
															class="label clickable"
														>
															<i class="ico ico-enactment-enactmentactivator ico-enactment-executable"></i>
															<div class="text">
																<span class="h4">{{ activator.label }}</span>
															</div>
														</a>
													}
													@if (isExecutionDisabled(processView)) {
														<div class="label">
															<i class="ico ico-enactment-enactmentactivator ico-enactment-executable"></i>
															<div class="text">
																<span class="h4">{{ activator.label }}</span>
															</div>
														</div>
													}
													@if (
														isStatus("success", activator.id) &&
														processView.enactmentActivatorExecutionContainer!.isReadyForExecution
													) {
														<i
															class="ico ico-check success-color result-icon"
															(click)="openResultsDialogFromActivator(activator.id)"
														></i>
													}
													@if (
														isStatus("failure", activator.id) &&
														processView.enactmentActivatorExecutionContainer!.isReadyForExecution
													) {
														<i
															class="ico ico-warning error-color result-icon"
															(click)="openResultsDialogFromActivator(activator.id)"
														></i>
													}
													@if (
														isStatus("warnings", activator.id) &&
														processView.enactmentActivatorExecutionContainer!.isReadyForExecution
													) {
														<i
															class="ico ico-warning warning-color result-icon"
															(click)="openResultsDialogFromActivator(activator.id)"
														></i>
													}
													@if (!processView.enactmentActivatorExecutionContainer!.isReadyForExecution) {
														<i class="ico ico-warning warning-color result-icon" (click)="openNotReadyDialog()"></i>
													}
													<stages-menu
														menuId="executable-activator-menu"
														iconClasses="ico ico-more-vertical"
														openTo="left"
														[items]="menuItems"
														[context]="{ processView: processView, activatorView: activator }"
														[noCollapse]="false"
														class="action"
														[ngClass]="{ 'menu-ivisible': inProgressActivatorId }"
													></stages-menu>
													@if (showSpinner(activator.id)) {
														<stages-spin size="sm"></stages-spin>
													}
												</li>
											}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</li>
				}
				@if (processView.enactmentActivatorExecutionContainer!.results.items.length > 0) {
					<li class="group">
						<header class="group-header">
							<span class="h3"
								(click)="toggle(resultsGroupIdent)"
								translate="process.enactment.activator.execution.resultssection"
							></span>
							<span class="counter">{{
								processView.enactmentActivatorExecutionContainer!.results.totalItemCount
							}}</span>
							<stages-button-expand-collapse
								[classes]="'action menu-button'"
								[isCollapsed]="!isGroupOpen(resultsGroupIdent)"
								(pressedButton)="toggle(resultsGroupIdent)"
							></stages-button-expand-collapse>
						</header>
						<div class="relative-container">
							<div class="animation-container">
								<div
									#expandableResultsGroup
									class="stages-expand-collapse-from-top"
									[class.stages-expanded]="isGroupOpen(resultsGroupIdent)"
									[class.stages-collapsed]="!isGroupOpen(resultsGroupIdent)"
								>
									<div>
										<ul class="list dense">
											@for (result of processView.enactmentActivatorExecutionContainer?.results?.items; track result) {
												<li class="list-item">
													<a class="label clickable" (click)="openResultsDialogFromList(result)">
														@if (result.status === "warnings") {
															<i class="ico ico-warning warning-color"></i>
														}
														@if (result.status === "failure") {
															<i class="ico ico-warning error-color"></i>
														}
														@if (result.status === "success") {
															<i class="ico ico-check success-color"></i>
														}
														<div class="text">
															<span class="h4">{{ result.title }}</span>
														</div>
													</a>
												</li>
											}
											@if (hasMoreResults(processView.enactmentActivatorExecutionContainer!.results)) {
												<li class="list-item">
													<a
														class="label clickable"
														(click)="loadMoreResults(processView.enactmentActivatorExecutionContainer!.results)"
													>
														<div class="text center">
															<span class="show-more center" translate="more"></span>
														</div>
													</a>
												</li>
											}
										</ul>
									</div>
								</div>
							</div>
						</div>
					</li>
				}
			</ul>
		}
	</article>
}
